<template>
  <div>
    <!-- accepted appointment list -->
    <bill-appointments-list
      :listTitle="'selectOtherAppointments'"
      :billAppointmentsFullList="items"
      :selectedBillAppointments="billAppointments"
      @selectedbillappointmentsupdated="setSelectedBillAppointments"
      ><slot slot="filters" name="filters"></slot
    ></bill-appointments-list>
    <!-- lower buttons -->
    <v-row class="no-gutters justify-space-between">
      <v-col class="col-12 col-sm-auto mb-3">
        <v-btn
          color="primary"
          class="caption font-weight-bold"
          :disabled="!hasBillAppointments"
          rounded
          depressed
          block
          @click="openConfirmDialog"
          >{{ $t("billAppointments.markAsNotDone") }}</v-btn
        >
      </v-col>
      <v-col class="col-12 col-sm-auto mb-3">
        <v-btn
          color="primary"
          class="caption font-weight-bold"
          :disabled="!hasBillAppointments"
          depressed
          rounded
          block
          @click="openAcceptedAppointmentToSetDoneDialog"
          >{{ $t("billAppointments.markAsDoneAddToBill") }}</v-btn
        >
      </v-col>
    </v-row>

    <!-- dialog to set DONE to appointment -->
    <v-dialog
      v-model="acceptedAppointmentToSetDoneDialogStatus"
      persistent
      width="85%"
    >
      <v-card color="cardbg" class="pa-2">
        <v-card-title class="title font-weight-bold pa-2">
          {{ $t("billAppointments.addAppointmentsModal.title") }}
        </v-card-title>
        <v-card-subtitle
          class="subtitle font-weight-bold card-text-color py-1 px-2"
        >
          <span v-if="isSanimpresaOffice">{{
            $t("billAppointments.addAppointmentsModal.subtitleSani")
          }}</span>
          <span v-else>{{
            $t("billAppointments.addAppointmentsModal.subtitle")
          }}</span>
        </v-card-subtitle>
        <v-card-text class="card-text-color py-3 px-2">
          <div class="scrollable-section">
            <accepted-appointment-modal-item
              v-for="(appointment, index) in formBillAppointments"
              :key="index"
              :appointment="appointment"
            />
          </div>
        </v-card-text>
        <v-row class="no-gutters justify-space-between pb-3 px-2">
          <v-col class="col-12 col-sm-auto">
            <v-btn
              color="primary"
              class="caption font-weight-bold"
              rounded
              outlined
              @click="closeAcceptedAppointmentToSetDoneDialog"
              >{{ $t("cancelButton") }}</v-btn
            > </v-col
          ><v-col class="col-12 col-sm-auto">
            <v-btn
              color="primary"
              class="caption font-weight-bold"
              rounded
              depressed
              @click="checkIfAllDeliveryDatesAreCompleted"
              >{{ $t("forwardButton") }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

    <!-- dialog to show verify appointments delivery dates result -->
    <appointments-delivery-date-results-dialog
      :visible="deliveryDateResultsDialogStatus"
      :appointmentsOutOfRangeResults="appsDeliveryDateOutOfRangeResults"
      :appointmentsOkResults="appsDeliveryDateOkResults"
      :appointmentsParzialeResults="appsDeliveryDateParzialeResults"
      :appointmentsKoResults="appsDeliveryDateKoResults"
      @close="deliveryDateResultsDialogStatus = false"
      @addacceptedappointment="addAcceptedAppointment"
      @closeandreloadpage="reloadBillAndProvidedServicesAndGoToBillPage"
    ></appointments-delivery-date-results-dialog>
  </div>
</template>

<script>
import dayjs from "dayjs";
import AppointmentsDeliveryDateResultsDialog from "./../AppointmentsDeliveryDateResultsDialog";
import AcceptedAppointmentModalItem from "./AcceptedAppointmentModalItem";
import BillAppointmentsList from "./BillAppointmentsList";

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    contentType: {
      type: String,
      required: true
    }
  },
  components: {
    BillAppointmentsList,
    AcceptedAppointmentModalItem,
    AppointmentsDeliveryDateResultsDialog
  },
  data() {
    return {
      content: {
        new: {
          initialize: this.initializeNewBill
        },
        edit: {
          initialize: this.initializeEditBill
        }
      },
      billAppointments: [],
      formBillAppointments: [],
      acceptedAppointmentToSetDoneDialogStatus: false,
      parentRouteName: "_billDetails",
      deliveryDateResultsDialogStatus: false,
      appsDeliveryDateOutOfRangeResults: [],
      appsDeliveryDateOkResults: [],
      appsDeliveryDateParzialeResults: [],
      appsDeliveryDateKoResults: []
    };
  },
  created() {
    this.content[this.contentType].initialize();
  },
  computed: {
    bill: {
      get() {
        return this.$store.getters["bills/activeBill"];
      },
      set(value) {
        //
      }
    },
    billId() {
      return this.$route.params.id;
    },
    hasBillAppointments() {
      return this.billAppointments.length > 0;
    },
    isSanimpresaOffice() {
      return this.$store.getters["hfManagement/isSanimpresaOffice"];
    }
  },
  methods: {
    initializeNewBill() {
      this.bill = null;
    },
    async initializeEditBill() {
      if (this.bill !== null && this.bill.id === this.billId) {
        this.$store.commit("billAppointments/SET_PAGE_DESC_PARAMS", {
          billProtocolCode: this.bill.protocolCode
        });
      } else {
        await this.$store.dispatch("bills/getBill");
        this.$store.commit("billAppointments/SET_PAGE_DESC_PARAMS", {
          billProtocolCode: this.bill.protocolCode
        });
      }
    },
    setSelectedBillAppointments(selectedBillAppointments) {
      this.billAppointments = selectedBillAppointments;
    },
    openConfirmDialog() {
      let confirmConfig = {
        title: "billAppointments.confirmDialog.notDone.title",
        message: "billAppointments.confirmDialog.notDone.msg",
        cancelBtnLabel: "cancelButton",
        confirmBtnLabel: "confirmButton",
        confirmBtnClb: this.markAppointmentsToNotDone
      };
      this.$store.commit("confirm/openConfirmDialog", confirmConfig, {
        root: true
      });
    },
    async markAppointmentsToNotDone() {
      for (let appointment of this.billAppointments) {
        await this.markAppointmentToNotDone(appointment);
      }
      let officeId = this.$store.getters["hfManagement/officeId"];
      await this.$store.dispatch("billAppointments/getItems", officeId);
      this.billAppointments = [];
    },
    async markAppointmentToNotDone(appointment) {
      await this.$store.dispatch(
        "appointments/callSetAppointmentToNotDone",
        appointment.appointmentId
      );
    },
    checkIfAllDeliveryDatesAreCompleted() {
      let numOfFormBillAppointments = this.formBillAppointments.length;
      let numOfCompletedFormBillAppointments = this.formBillAppointments.filter(
        a => {
          return a.delivery.date != null;
        }
      ).length;
      if (numOfFormBillAppointments === numOfCompletedFormBillAppointments) {
        // fondoest/issues#997: open warning dialog to verify delivery date values
        this.$store.commit("confirm/openConfirmDialog", {
          title: "billAppointments.verifyDeliveryDateDialog.title",
          message: "billAppointments.verifyDeliveryDateDialog.text",
          params: {},
          cancelBtnLabel: "cancelButton",
          cancelBtnClb: null,
          confirmBtnLabel: "confirmButton",
          confirmBtnClb: this.verifyAppointmentsDeliveryDates
        });
      } else {
        // open warning dialog for missing delivery date
        this.$store.commit("confirm/openConfirmDialog", {
          title: "billAppointments.emptyDeliveryDateDialog.title",
          message: "billAppointments.emptyDeliveryDateDialog.text",
          params: {},
          cancelBtnLabel: null,
          cancelBtnClb: null,
          confirmBtnLabel: "okButton",
          confirmBtnClb: null
        });
      }
    },
    // appointments done functions
    async verifyAppointmentsDeliveryDates() {
      let payload = {};
      let dates = [];
      for (let app of this.formBillAppointments) {
        let p = {
          appointment: app,
          appointmentId: app?.appointmentId,
          appointmentDeliveryDate: dayjs(
            `${app?.delivery?.date}T12:00`
          ).format()
        };
        dates.push(p);
      }
      payload["obj"] = { dates: dates };
      let result = await this.$store.dispatch(
        "appointments/callVerifyAppointmentDeliveryDate",
        payload
      );
      // Before the call to verifyAppointments, close previous dialog
      this.closeAcceptedAppointmentToSetDoneDialog();
      // Check the response to verifyAppointments and show results in this order:
      // 1. first of all, if there are results with OK or PARZIALE, create the bill if not exists yet. Then...
      // 2. if there are results with DATEOUTSIDERANGE, open an error dialog because the selected delivery date is invalid
      // 3. if there are results with KO, open a warning dialog and then mark all these appointments as ADMINISTRATIVE_CHECK_REQUIRED;
      // 4. if there are results with PARZIALE, open a warning dialog and then mark all these appointments as DONE;
      // 5. if there are results with OK, mark all these appointments as DONE;
      if (result.OK.length > 0 || result.PARZIALE.length > 0) {
        if (this.bill == null) {
          await this.$store.dispatch("bills/createBill");
        }
      }
      if (
        result.DATEOUTSIDERANGE.length > 0 ||
        result.KO.length > 0 ||
        result.PARZIALE.length > 0
      ) {
        this.appsDeliveryDateOutOfRangeResults = result.DATEOUTSIDERANGE;
        this.appsDeliveryDateOkResults = result.OK;
        this.appsDeliveryDateParzialeResults = result.PARZIALE;
        this.appsDeliveryDateKoResults = result.KO;
        this.deliveryDateResultsDialogStatus = true;
      } else {
        let payload = { apps: result.OK, needToReloadPage: true };
        await this.addAcceptedAppointment(payload);
      }
    },
    async addAcceptedAppointment(payload) {
      let appointments = payload.apps;
      let reloadPage = payload.needToReloadPage;
      for (let app of appointments) {
        await this.markAppointmentAsDoneAndAddToBill(app);
        await this.addProvidedServiceToBill(app);
      }
      if (reloadPage) {
        this.reloadBillAndProvidedServicesAndGoToBillPage();
      }
    },
    async markAppointmentAsDoneAndAddToBill(app) {
      await this.$store.dispatch(
        "billAppointments/callAddAcceptedAppointment",
        app
      );
    },
    async addProvidedServiceToBill(app) {
      await this.$store.dispatch("bills/addProvidedServiceToBill", app, {
        root: true
      });
    },
    async reloadBillAndProvidedServicesAndGoToBillPage() {
      await this.reloadBillAndProvidedServices();
      this.goToBillPage();
    },
    async reloadBillAndProvidedServices() {
      await this.$store.dispatch("bills/reloadBillAndProvidedServices", null, {
        root: true
      });
    },
    goToBillPage() {
      if (this.bill) {
        this.$router.push({
          name: this.parentRouteName,
          params: { id: this.bill.id }
        });
      } else {
        let params = {};
        this.$router.push({
          name: "_newBill",
          params
        });
      }
    },
    openAcceptedAppointmentToSetDoneDialog() {
      let date, hour, minutes, number, numberDisabled, iDate;
      this.formBillAppointments = this.billAppointments.map(appointment => {
        let appScheduleDate = appointment.appointmentScheduleDate;
        date = dayjs(appScheduleDate).format("YYYY-MM-DD");
        hour = "00";
        minutes = "00";
        number = this.isSanimpresaOffice ? "0" : "";
        numberDisabled = this.isSanimpresaOffice ? true : false;
        iDate = "";
        return {
          appointmentId: appointment.appointmentId,
          appointmentScheduleDate: appScheduleDate,
          serviceName: appointment?.hService?.longDescr,
          price: appointment.price,
          exemption: appointment.exemption,
          state: appointment.state,
          iupCode: appointment.iupCode,
          memberName: appointment.memberName,
          memberSurname: appointment.memberSurname,
          memberCodiceFiscale: appointment.memberCodiceFiscale,
          doctorId: appointment.doctorId,
          doctorName: appointment.doctorName,
          doctorSurname: appointment.doctorSurname,
          delivery: {
            date,
            hour,
            minutes
          },
          invoice: {
            number,
            numberDisabled,
            iDate,
            total: appointment.invoiceTotal
          }
        };
      });
      this.acceptedAppointmentToSetDoneDialogStatus = true;
    },
    closeAcceptedAppointmentToSetDoneDialog() {
      this.acceptedAppointmentToSetDoneDialogStatus = false;
      this.formBillAppointments = [];
    }
  }
};
</script>

<style scoped>
.scrollable-section {
  max-height: calc(2 * 200px);
  overflow: auto;
}
</style>
